module.exports = __webpack_public_path__ + "media/images/design/common/images/mark_header_navi-08bad93bc0088913dd50a052644aed4e.png";